module.exports = __webpack_public_path__ + "img/r2.fa223ef4.jpg";